import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
  chartTitle: { flexGrow: 1 },
  chartToolbar: { padding: 0, marginBottom: 20 },
  chartWrapper: {
    height: '100%',
  },
}));
